import { interceptor } from "./interceptor";

export const getSessionTokenService = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v1/auth/get-session-token";
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...headers
    },
    showMsg: false
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};
export const getAccessTokenService = async (userInput) => {
  const { headers, body } = userInput;
  // console.log(userInput);
  const url = "/v1/auth/get-access-token";
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...headers
    },
    showMsg: false
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const SendAdharOTPServices = async (userInput) => {
  const { headers, body } = userInput;
  console.log(userInput);
  const url = "/v3/abha/send-aadhar-otp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    },
    showMsg: false
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const VerifyAdharOTPServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/verify-aadhar-otp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const SendMobileOTPServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/sendMobileOtp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const SendMobileOTPServicesToUpdateMobile = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/update/send-mobile-otp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const verifyMobileOTPServicesToUpdateMobile = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/update/verify-mobile-otp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const VerifyMobileOTPServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/verifyMobileOtp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const abhaSuggestionsServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/getAbhaSuggestions";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};
export const abhaCreateServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/createAbhaAddress";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};
export const abhaCartDownloadServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/downloadAbhaCard";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const abhaCartDownloadServicesVerification = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/verificationFlow/downloadAbhaCard";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const generateAbhaSessionServices = async () => {
  const url = "/v3/abha/generateAbhaSession";
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    },
    showMsg: false
  };
  // if (Object.keys(body).length > 0) {
  //   options.body = JSON.stringify(body);
  // }
  const response = await interceptor(url, options);

  return response;
};

export const MobileOTPServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/external/send-otp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const EncryptServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/encryptData";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);
  if (response.success) {
    return response.data;
  } else {
    throw response.message;
  }
};

export const mobileOtpVerifyServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/external/verify-otp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };

  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }

  try {
    const response = await interceptor(url, options);
    return response;
  } catch (error) {
    console.error("OTP verification failed:", error);
    throw error;
  }
};

export const UpdateAbhaUserServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/external/update-user";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};
export const createAbhaUserServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/external/create-user";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};

export const AlreadyAbhaNumberSearch = async (userInput) => {
  const { headers, data } = userInput;
  const url = "/v3/abha/search";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(data).length > 0) {
    options.body = JSON.stringify(data);
  }
  const response = await interceptor(url, options);

  return response;
};
export const SendAadharOtp = async ({ headers, data }) => {
  console.log("data", data);
  const url = "/v3/abha/verificationOTP/send";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      "abha-session": localStorage.getItem("abhaSessionToken"),
      ...headers
    },
    body: JSON.stringify(data)
  };
  console.log("options", options);
  const response = await interceptor(url, options);

  return response;
};
export const AbhaViaSendAadharOtp = async (userInput) => {
  const { headers, data } = userInput;
  const url = "/v3/abha/verificationOTP/send";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      "abha-session": localStorage.getItem("abhaSessionToken"),
      ...headers
    },
    body: JSON.stringify(data)
  };
  console.log("options", options);
  const response = await interceptor(url, options);

  return response;
};
export const AbhaViaSendAbhaOtp = async (userInput) => {
  const { headers, data } = userInput;
  console.log("data4444", data);
  const url = "/v3/abha/verificationOTP/send";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      "abha-session": localStorage.getItem("abhaSessionToken"),
      ...headers
    },
    body: JSON.stringify(data)
  };
  console.log("options44444", options);
  const response = await interceptor(url, options);

  return response;
};
export const VerifySendAadharOtp = async (userInput) => {
  const { headers, data } = userInput;
  console.log("data", data);
  const url = "/v3/abha/verificationOTP/verify";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      "abha-session": localStorage.getItem("abhaSessionToken"),
      ...headers
    },
    body: JSON.stringify(data)
  };
  console.log("options", options);
  const response = await interceptor(url, options);

  return response;
};
export const VerifyAbhaViaSendAadharOtp = async (userInput) => {
  const { headers, data } = userInput;
  const url = "/v3/abha/verificationOTP/verify";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      "abha-session": localStorage.getItem("abhaSessionToken"),
      ...headers
    },
    body: JSON.stringify(data)
  };
  console.log("options", options);
  const response = await interceptor(url, options);

  return response;
};
export const VerifyAbhaViaSendAbhaOtp = async (userInput) => {
  const { headers, data } = userInput;
  console.log("data4444", data);
  const url = "/v3/abha/verificationOTP/verify";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      "abha-session": localStorage.getItem("abhaSessionToken"),
      ...headers
    },
    body: JSON.stringify(data)
  };
  console.log("options44444", options);
  const response = await interceptor(url, options);

  return response;
};
export const VerifyAbhaViaSendAbhaAddress = async (userInput) => {
  const { headers, data } = userInput;
  console.log("data4444", data);
  const url = "/v3/abha/verificationOTP/verify/abhaAddress";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      "abha-session": localStorage.getItem("abhaSessionToken"),
      ...headers
    },
    body: JSON.stringify(data)
  };
  console.log("options44444", options);
  const response = await interceptor(url, options);

  return response;
};
export const EncryptDataABDM = async (userInput) => {
  console.log("userInput", userInput);
  const { headers, body } = userInput;
  console.log("3");
  const url = "/v3/abha/encrypt-data";
  console.log("4");
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify({ data: body });
  }
  const response = await interceptor(url, options);

  return response;
};
export const SendAbhaOTPServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/send-otp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};
export const VerifyAbhaOTPServices = async (userInput) => {
  const { headers, body } = userInput;
  const url = "/v3/abha/verify-otp";
  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };
  if (Object.keys(body).length > 0) {
    options.body = JSON.stringify(body);
  }
  const response = await interceptor(url, options);

  return response;
};
export const AlreadyAbhaVerifyNumber = async (userInput) => {
  const { headers, data } = userInput;
  const url = "/v3/abha/verificationOTP/send";

  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };

  if (Object.keys(data).length > 0) {
    options.body = JSON.stringify(data);
  }

  const response = await interceptor(url, options);

  return response;
};
export const AlreadyAbhaVerifyAddress = async (userInput) => {
  const { headers, data } = userInput;
  const url = "/v3/abha/verificationOTP/send/abhaAddress";

  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };

  if (Object.keys(data).length > 0) {
    options.body = JSON.stringify(data);
  }

  const response = await interceptor(url, options);

  return response;
};
export const VerifyAbhaOtp = async (userInput) => {
  const { headers, data } = userInput;
  const url = "/v3/abha/search/verify-otp-mobile";

  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };

  if (Object.keys(data).length > 0) {
    options.body = JSON.stringify(data);
  }

  const response = await interceptor(url, options);
  return response;
};
export const SearchUsingAbhaAddress = async (userInput) => {
  const { headers, data } = userInput;
  const url = "/v3/abha/search/using_abha_address";

  const options = {
    method: "POST",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };

  if (Object.keys(data).length > 0) {
    options.body = JSON.stringify(data);
  }

  const response = await interceptor(url, options);
  return response;
};
export const UpdateAbhaUserDetails = async (userInput) => {
  const { headers, data } = userInput;
  const url = "/v3/abha/update/details";

  const options = {
    method: "PUT",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };

  if (Object.keys(data).length > 0) {
    options.body = JSON.stringify(data);
  }

  const response = await interceptor(url, options);
  return response;
};
export const SendOTPMobileUpdateDetails = async (userInput) => {
  const { headers, data } = userInput;
  const url = "/v3/profile/account/request/otp";

  const options = {
    method: "PUT",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };

  if (Object.keys(data).length > 0) {
    options.body = JSON.stringify(data);
  }

  const response = await interceptor(url, options);
  return response;
};
export const VerifyOTPMobileUpdateDetails = async (userInput) => {
  const { headers, data } = userInput;
  const url = "/v3/profile/account/verify";

  const options = {
    method: "PUT",
    isToken: true,
    headers: {
      "Content-Type": "application/json",
      ...headers
    }
  };

  if (Object.keys(data).length > 0) {
    options.body = JSON.stringify(data);
  }

  const response = await interceptor(url, options);
  return response;
};
